export const removeMedianToken = () => {
  if (navigator.userAgent.indexOf("median") > -1 || window.median !== undefined) {
    window.median?.storage?.app.delete({
      key: "token",
    });
  }
};
